import { range } from 'ramda'
import React, { useMemo } from 'react'

import Select from '../../packages/kiti/components/form/Select'
import Text from '../../packages/kiti/components/presentation/Text'
import { Col } from '../../packages/kiti/components/structure/Grid'

const times = range(0, 24).reduce(
  (options, h) => [...options, ...range(0, 4).map(m => `${String(h).padStart(2, '0')}:${m * 15 || '00'}`)],
  []
)

export function convertToMinutes(time) {
  if (!time) return time
  const [hours, minutes] = time.split(':')
  const hourInMinutes = Number(hours) * 60
  return hourInMinutes + Number(minutes)
}

const TimeSelect = ({ label, field, value, onChange, index, inMinutes, showOnlySince, ...props }) => {
  const handleChange = time => {
    if (!time) {
      onChange(null)
      return
    }
    if (inMinutes) {
      const valueInMinutes = convertToMinutes(time)
      onChange(valueInMinutes, index)
      return
    }
    onChange(time, index)
  }

  const formatValue = value => {
    if (!value && value !== 0) return
    if (inMinutes) {
      const hours = String(Math.trunc(value / 60)).padStart(2, '0')
      const minutes = String(value % 60).padStart(2, '0')
      return `${hours}:${minutes}`
    }
    return value
  }

  const filteredTimes = useMemo(() => {
    if (!showOnlySince) return times
    const result = times.filter(time => {
      if (inMinutes) return time > showOnlySince
      const valueInMinutes = convertToMinutes(time)
      return valueInMinutes > showOnlySince
    })
    return result
  }, [showOnlySince, inMinutes])

  return (
    <>
      <Col width={'100%'}>
        <Select
          onChange={handleChange}
          Input={Select}
          options={filteredTimes}
          value={formatValue(value)}
          disablePagination
          {...props}
        />
      </Col>
      <Text>{label}</Text>
    </>
  )
}

export default TimeSelect
